import _ from 'lodash';
import cianAdFox from '@cian/adfox/build/angular';

angular.module('cian.advancedBrowser')
  .controller('AdvancedBrowserPopupCtrl', [
    'FilterService',
    'FilterTermsService',
    '$uibModalInstance',
    'ads',
    'MetroService',
    'AvailableFilters',
    '$http',
    'MetaService',
    'AnalyticsService',
    function (FilterService, FilterTermsService, $uibModalInstance, ads, MetroService, AvailableFilters, $http, MetaService, AnalyticsService) {
      const ctrl = this;

      ctrl.ads = ads;

      // Количество комнат в квартире (для комнаты/койкоместа/доли)
      const filterRoomsCount = FilterService.filter.rooms_count;
      ctrl.roomsCount = (filterRoomsCount && filterRoomsCount.value && filterRoomsCount.value.length) ?
        filterRoomsCount.value[0] : null;
      ctrl.setRoomsCount = () => {
        filterRoomsCount.value = ctrl.roomsCount ? [ctrl.roomsCount] : null;
      };

      ctrl.defaultOnlyFootValue = MetroService.FOOT_MIN_DEFAULT;

      ctrl.close = () => {
        AnalyticsService.trackCA('Listing', 'popup_more_param_show_objects_click', MetaService.lastMeta && MetaService.lastMeta.url, {});
        $uibModalInstance.close();
      };

      ctrl.bannerMiddleware = () => cianAdFox.mergeMiddlewares(
        cianAdFox.calculatedParamsMiddleware(),
        Promise.resolve({
          p1: 'bwgxy',
          p2: 'fmsa',
          /* Таргетинги */
          puid1: `deal_type_${FilterService.dealType}`,
          puid2: `offer_${FilterService.category}`,
          puid5: `obl_id_${FilterService.selectedRegions[0].id}`,
        })
      );

      // "Только апартаменты" и "Без апартаментов" должны работать как радио
      ctrl.updateApartments = () => {
        if (FilterService.filter.apartment.value) FilterService.filter.only_flat.value = null;
      };
      ctrl.updateOnlyFlat = () => {
        if (FilterService.filter.only_flat.value) FilterService.filter.apartment.value = null;
      };


      /*
       Данные для коммерческой
       */
      if (FilterService.categoryIs('commercial')) {
        ctrl.isStreetRetail = () => _.includes(
          _.get(FilterService.filter, 'placement_type.value'), 2
        );

        /**
         * Проверяет, что выбран только данный тип гаража
         * @param {string} type - тип гаража: garage/box
         * @returns {boolean}
         */
        ctrl.garageTypeIs = type => {
          const currentGarageTypes = _.get(FilterService.filter, 'garage_type.value');

          if (currentGarageTypes) {
            const GARAGE_TYPES = {
              garage: 2,
              box: 3,
            };
            return _.isEqual(currentGarageTypes, [GARAGE_TYPES[type]]);
          }
        };

        // Определяем список фильтров инфраструктуры
        const infrastructureTerms = FilterTermsService.getInfrastructureFor(
          _.map(FilterService.objectTypes, 'name')
        );
        if (infrastructureTerms.length) {
          const columnLength = Math.ceil(infrastructureTerms.length / 3);
          const sortedInfrastructure = _.sortBy(infrastructureTerms,
            term => FilterTermsService.infrastructure.all[term]
          );
          /** @memberOf advancedPopup */
          ctrl.infrastructureColumns = _.chunk(sortedInfrastructure, columnLength);
        }

        ctrl.getSpecialtyTypes = (query) => {
          return $http.get(`/cian-api/site/v1/get-specialties/?term=${query}`, {
            cache: true
          })
            .then(res => _.map(res.data.data.specialties,
              item => ({
                text: item.rusName,
                value: item.id,
              })
            ))
            .catch(() => {
              Notifications.add({
                type: 'error',
                content: 'Не удалось получить список возможных назначений, попробуйте повторить попытку позже.',
                timeout: 5000
              });
            });
        };
      }

      /**
       * Какие контролы надо показывать
       * @memberOf advancedPopup
       * @return {boolean}
       */
      ctrl.shouldShow = filterName => _.includes(availableFilters, filterName);

      const availableFilters = AvailableFilters.getFiltersList(
        FilterService.dealType,
        FilterService.isShortTerm(),
        FilterService.category,
        _.map(FilterService.objectTypes, 'name')
      );
    }]);



// WEBPACK FOOTER //
// ./src/components/advanced-browser/src/scripts/cian.advanced-browser.popup.ctrl.js